import React, { useState } from 'react';
import {
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TableCell,
    TableRow,
} from '@mui/material';
import { timeAgo } from '../shared/utility/timeAgo';

export function isHeartbeatAlive(timestamp, maxAgeMs, now = Date.now()) {
    const heartbeatTime = new Date(timestamp).getTime();
    return Number.isFinite(heartbeatTime)
        && Number.isFinite(maxAgeMs)
        && now - heartbeatTime <= maxAgeMs;
}

function formatHeartbeat(timestamp) {
    const date = new Date(timestamp);
    return Number.isFinite(date.getTime())
        ? date.toISOString().replace('T', ' ').replace('Z', ' UTC')
        : 'Invalid timestamp';
}

function Heartbeat({ sensor, heartbeat = {}, maxAgeMs, now = Date.now() }) {
    const [jsonOpen, setJsonOpen] = useState(false);
    const timestamp = heartbeat?.timestamp;
    const alive = isHeartbeatAlive(timestamp, maxAgeMs, now);

    return (
        <>
            <TableRow>
                <TableCell>{sensor}</TableCell>
                <TableCell>{formatHeartbeat(timestamp)}</TableCell>
                <TableCell>{heartbeat?.firmware || '—'}</TableCell>
                <TableCell>
                    <Chip
                        label={alive ? 'Alive' : 'Stale'}
                        color={alive ? 'success' : 'error'}
                        size="small"
                    />
                </TableCell>
                <TableCell>{timeAgo(timestamp)}</TableCell>
                <TableCell>
                    <Button size="small" variant="outlined" onClick={() => setJsonOpen(true)}>
                        View JSON
                    </Button>
                </TableCell>
            </TableRow>

            <Dialog open={jsonOpen} onClose={() => setJsonOpen(false)} fullWidth maxWidth="md">
                <DialogTitle>Heartbeat JSON — {sensor}</DialogTitle>
                <DialogContent>
                    <pre style={{ margin: 0, overflowX: 'auto', whiteSpace: 'pre-wrap' }}>
                        {JSON.stringify(heartbeat, null, 2)}
                    </pre>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setJsonOpen(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default Heartbeat;
